const ICON_COLOR_STYLE_GREEN = 'iconColorStyleGreen';
const ICON_COLOR_STYLE_ORANGE = 'iconColorStyleOrange';
const ICON_COLOR_STYLE_RED = 'iconColorStyleRed';
const ICON_COLOR_STYLE_PURPLE = 'iconColorStylePurple';
const ICON_COLOR_STYLE_GREY = 'iconColorStyleGrey';

export const ICON_COLOR_STYLE_NAMES = {
  ICON_COLOR_STYLE_GREEN: ICON_COLOR_STYLE_GREEN,
  ICON_COLOR_STYLE_ORANGE: ICON_COLOR_STYLE_ORANGE,
  ICON_COLOR_STYLE_RED: ICON_COLOR_STYLE_RED,
  ICON_COLOR_STYLE_PURPLE: ICON_COLOR_STYLE_PURPLE,
  ICON_COLOR_STYLE_GREY: ICON_COLOR_STYLE_GREY,
};

/**
 * CSS style class for custom border radius, add style property to the element passing value for css variable *--custom-border-radius*.
 * The border radius, if not specified, defaults to 6px.
 */
export const BORDER_RADIUS_STYLE_NAME = 'customBorderRadius';

const styles = theme => ({
  '@global': {
    '.noPadding': {
      padding: 0,
    },
    '.fillScreen': {
      width: '100vw',
      height: '100vh',
    },
    '.fullWidth': {
      width: '100%',
      maxWidth: '100%',
    },
    '.fullHeight': {
      height: '100%',
      maxHeight: '100%',
    },
    '.contentMarginTop': {
      marginTop: theme.spacing(1),
    },
    '.fitContentWidth': {
      maxWidth: 'fit-content',
    },
    '.error': {
      color: 'red',
    },
    [`.${ICON_COLOR_STYLE_GREEN}`]: {
      color: '#64ab16',
      backgroundColor: 'rgba(126, 211, 33, 0.12)',
    },
    [`.${ICON_COLOR_STYLE_ORANGE}`]: {
      color: '#f5a623',
      backgroundColor: 'rgba(245, 166, 35, 0.12)',
    },
    [`.${ICON_COLOR_STYLE_RED}`]: {
      color: '#ff4540',
      backgroundColor: 'rgba(255, 67, 62, 0.12)',
    },
    [`.${ICON_COLOR_STYLE_PURPLE}`]: {
      color: '#3a3df2',
      backgroundColor: 'rgba(58, 61, 242, 0.12)',
    },
    [`.${ICON_COLOR_STYLE_GREY}`]: {
      color: '#989898',
      backgroundColor: '#e7e7e7',
    },
    [`.${BORDER_RADIUS_STYLE_NAME}`]: {
      borderRadius: 'var(--custom-border-radius, 6px)',
    },
  },
});

export default styles;
